import styled from 'styled-components';
import { BreakpointsEnum } from '@/landing/types';
import apx from '@/landing/constants/adaptivepx';

export const Title = styled.div`

  font-size: ${ apx.d( 27 ) };
  font-weight: 700;
  line-height: 120%;
  color: rgba(33, 39, 49, 0.8);

  margin-bottom: ${ apx.d( 10 ) };

  @media (max-width: ${BreakpointsEnum.sm}px) {

    font-size: ${ apx.m( 20 ) };
    line-height: ${ apx.m( 24 ) };

    margin-bottom: ${ apx.m( 8 ) };

  }

  br{

    display: none;

    @media (max-width: ${BreakpointsEnum.sm}px) {

      display: block;

    }

  }

`;

export const Text = styled.div`

  font-size: ${ apx.d( 18 ) };
  font-weight: 400;
  line-height: 140%;
  color: #212731CC;

  @media (max-width: ${BreakpointsEnum.sm}px) {

    width: ${ apx.m( 343 ) };

    font-size: ${ apx.m( 16 ) };
    line-height: ${ apx.m( 20 ) };

    margin-top: ${ apx.m( 12 ) }

  }

`;

export const FindChildTherapistWrap = styled.div`

  margin-bottom: ${ apx.d( 50 ) };

   @media (max-width: ${BreakpointsEnum.sm}px) {

    margin-bottom: ${ apx.m( 17 ) };

  }

`;
